export enum Endpoints {
    GENERATE_UPLOAD_TARGETS = '/generate-upload-targets',
    SIGN_UPLOAD = '/sign-upload',
}
